<template>
  <router-view />
  <BaseNotifications />
  <TheCssBreakpointDetector />
</template>

<script setup lang="tsx">
import LogoConnect from "@/components/LogoConnect.vue";
import { routeNames } from "@/routes";
import { TheCssBreakpointDetector, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { BaseNotifications } from "@modernary/mui/components/notifications";

const appSettingsStore = useAppSettingsStore();
const { setNavigationItems, setApplicationTitleComponent, setSuiteLogoComponent } = useAppNav();

const titleComponent = () => <div>{appSettingsStore.applicationTitle}</div>;
setApplicationTitleComponent(titleComponent);

const connectUrl = import.meta.env.VITE_CONNECT_URL;

if (connectUrl) {
  setSuiteLogoComponent(() => (
    <a
      class="ml-1 flex items-center rounded-l-full bg-neutral-300 pl-3 pr-3 hover:bg-neutral-400 md:ml-6"
      href={connectUrl}
      target="_blank"
      aria-label="EHA Connect"
    >
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </a>
  ));
} else {
  setSuiteLogoComponent(() => (
    <div class="ml-1 flex items-center rounded-l-full bg-neutral-300 pl-3 pr-3 md:ml-6">
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </div>
  ));
}

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [
      { label: "Home", name: routeNames.home },
      { label: "Organizations", name: routeNames.organizations.organizations },
    ],
  },
  {
    label: "SDAR",
    className: "",
    items: [{ label: "Sites", name: routeNames.sites.sites }],
  },
  {
    label: "EP&R",
    className: "",
    items: [
      { label: "Incidents", name: routeNames.incidents.incidents },
      { label: "HEPCRA Facilities", name: routeNames.facilities.facilities },
    ],
  },
  {
    label: "Hazard Evaluation",
    className: "",
    items: [{ label: "Inquiries", name: routeNames.inquiries.inquiries }],
  },
]);
</script>
